module.exports = __webpack_public_path__ + "static/img/alps_fail_default.a146109e.webp";